export default __webpack_public_path__ + "static/media/Reader's Leggings of the Effulgent Blade.eaa4c28d.jpg";